<header class="dialog-header">
  <div class="dialog-title">
    <h2 id="dialogo-exemplos-titulo">Exemplos</h2>
    <p>Busque um exemplo e abra em uma nova aba para editar e executar.</p>
  </div>

  <button type="button" class="icon-btn" aria-label="Fechar" appTooltip="Fechar" (click)="dialogRef.close()">
    <svg-icon src="assets/mdi/close.svg" aria-hidden="true" />
  </button>
</header>

<div class="examples">
  <div class="list">
    <label class="search">
      <svg-icon src="assets/mdi/magnify.svg" aria-hidden="true" />
      <input
        type="search"
        placeholder="Buscar exemplos…"
        aria-label="Buscar exemplos"
        aria-controls="example-list"
        autocomplete="off"
        cdkFocusInitial
        [attr.aria-activedescendant]="current ? `example-${current.id}` : null"
        [ngModel]="query"
        (ngModelChange)="search($event)"
        (keydown)="onSearchKeydown($event)"
      />
    </label>

    <div
      id="example-list"
      class="items"
      role="listbox"
      tabindex="0"
      aria-label="Exemplos"
      [attr.aria-activedescendant]="current ? `example-${current.id}` : null"
      (keydown)="onSearchKeydown($event)"
    >
      @if (loading) {
        <div class="spinner" role="status" aria-label="Carregando exemplos"></div>
      } @else {
        @for (group of groups; track group.category) {
          <div class="group" role="group" [attr.aria-label]="group.category">
            <div class="group-heading" aria-hidden="true">{{ group.category }}</div>

            @for (entry of group.entries; track entry.item.id) {
              <div
                class="item"
                role="option"
                tabindex="-1"
                [id]="`example-${entry.item.id}`"
                [class.active]="current?.id === entry.item.id"
                [attr.aria-selected]="current?.id === entry.item.id"
                (click)="onItemClick(entry.item)"
                (dblclick)="openExample(entry.item)"
                (keydown.enter)="openExample(entry.item)"
              >
                <svg-icon src="assets/mdi/file-code-outline.svg" aria-hidden="true" />
                <span class="item-name">{{ entry.item.name }}</span>
                @if (entry.path.length) {
                  <span class="item-path">{{ entry.path.join(" › ") }}</span>
                }
              </div>
            }
          </div>
        } @empty {
          <p class="empty">Nenhum exemplo encontrado.</p>
        }
      }
    </div>
  </div>

  <div class="preview">
    @if (current) {
      <div class="preview-header">
        <div class="preview-text">
          <h3>{{ current.name }}</h3>
          <p #description id="example-description" [class.expanded]="descriptionExpanded">{{ current.description }}</p>
          <button
            class="read-more"
            type="button"
            aria-controls="example-description"
            [hidden]="!descriptionClamped() && !descriptionExpanded"
            [attr.aria-expanded]="descriptionExpanded"
            (click)="toggleDescription()"
          >
            {{ descriptionExpanded ? "Leia menos" : "Leia mais" }}
          </button>
        </div>
      </div>

      <div class="preview-code">
        <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="exampleCode" (init)="editor = $event" />
      </div>
    } @else if (!loading) {
      <p class="preview-empty">Nenhum exemplo para mostrar.</p>
    }

    @if (!loading) {
      <div class="preview-footer">
        <span class="preview-hint"><kbd>Enter</kbd> abre o exemplo escolhido</span>
        <button
          type="button"
          class="btn btn-primary open-button"
          [attr.aria-disabled]="!current || null"
          (click)="openCurrent()"
        >
          <svg-icon src="assets/mdi/tab-plus.svg" aria-hidden="true" />
          Abrir exemplo
        </button>
      </div>
    }
  </div>
</div>
